<template>
    <el-collapse v-model="chargeCode.filtersOpen">
        <el-collapse-item :title="$t('common.search')" name= "charge-code-search-section" id="charge-code-search-section">
            <el-form
                id="charge-codes-search-section-form"
                :model="searchForm"
                ref="searchForm"
                label-position="right"
                size="mini"
                class="search-section-form"
                inline
                >
                    <el-row >
                        <!-- Charge COde Name  -->
                        <el-col :span="8" >
                            <el-form-item :label="$t('tariff.chargeCodes.name')" prop="chargeCodeName" ref="chargeCodeName">
                                <autocomplete
                                :model.sync="searchForm.name"
                                :url="urlChargeCode"
                                :placeholder="$t('tariff.chargeCodes.searchChargeCodeOrName')"
                                labelField="name"
                                popperAppendToBody
                                labelFieldLastWithDash="code"
                                valueField="name"
                                ref="autocomplete-input"
                                />
                            </el-form-item>
                        </el-col>

                        <!-- Charge Code Type   -->
                        <el-col :span="8">
                            <el-form-item :label="$t('tariff.chargeCodes.type')">
                                <charge-code-type-select v-model="searchForm.type" :default-all="true" />

                            </el-form-item>
                        </el-col>

                        <!-- Charge Code Status   -->
                        <el-col :span="8">
                            <el-form-item :label="$t('tariff.chargeCodes.status')">
                               <status-filter v-model="searchForm.status" />

                            </el-form-item>
                        </el-col>

                    </el-row>

                    <el-row :gutter="10">
          <el-col :span="24" class="text-align-end">
            <el-tooltip
              :content="$t('common.search')"
              class="item"
              effect="dark"
              placement="top-start"
            >
              <el-button
                id="bill-of-lading-search-section-form-button"
                class="button-action-default"
                @click="handleSearch"
                icon="el-icon-search"
                size="mini"
              ></el-button>
            </el-tooltip>
          </el-col>
        </el-row>
            </el-form>
        </el-collapse-item>
    </el-collapse>
</template>

<script>
import { mapGetters } from 'vuex';
import { CHARGE_CODE_LIST_SEARCH } from '@/store/actions';
import Autocomplete from '@/components/Autocomplete/index';
import apiConstants from '@/utils/apiConstants';
import ChargeCodeTypeSelect from './components/chargeCodeTypes/chargeCodeTypeSelect';
import StatusFilter from './components/chargeCodeStatus/ChargeCodeStatusFilter';

export default {
  name: 'SearchFilterList',
  components: {
    ChargeCodeTypeSelect,
    Autocomplete,
    StatusFilter
  },
  computed: {
    ...mapGetters(['chargeCode']),
  },
  data() {
    return {
      searchForm: {
        name: null,
        type: null,
        status: 'active'
      },
      urlChargeCode: apiConstants.END_POINTS.BILLING.CHARGE_CODE_LIST_SEARCH,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$store.dispatch(CHARGE_CODE_LIST_SEARCH, this.searchForm);
    });
  },
  methods: {
    handleSearch() {
      this.$store.dispatch(CHARGE_CODE_LIST_SEARCH, { ...this.searchForm, orderField: null });
    },

  }
};
</script>
